import React, {useState} from "react";
import PropTypes from "prop-types";
import {getMediaThumbSrc} from "../../helpers/mediaUrl";
import Button from "../Button/Button";


const ITEMS_PER_PAGE = 6

const StandProducts = (props) => {

  const {products} = props
  const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE)

  if (!products || products.length === 0) {
    return null
  }

  const formatPrice = (price) => {
    if (price === null || price === undefined) return null
    return '\u20AC ' + parseFloat(price).toFixed(2).replace('.', ',')
  }

  const visibleProducts = products.slice(0, visibleCount)
  const hasMore = products.length > visibleCount

  return (
    <div className="component-stand-products">
      <h3>Aanbod</h3>
      <div className="products-grid">
        {visibleProducts.map((product, i) => {
          const thumbSrc = getMediaThumbSrc(product.media)
          const priceDisplay = formatPrice(product.price)

          return (
            <div key={product.id || i} className="product-card">
              {thumbSrc &&
                <div className="product-card-image">
                  <img src={thumbSrc} alt={product.label} loading="lazy"/>
                </div>
              }
              <div className="product-card-content">
                <h4>{product.label}</h4>
                {priceDisplay &&
                  <p className="product-price">{priceDisplay}</p>
                }
                {product.description &&
                  <p className="product-description">{product.description}</p>
                }
              </div>
            </div>
          )
        })}
      </div>
      {hasMore &&
        <div className="products-show-more">
          <Button
            label={'Toon meer (' + (products.length - visibleCount) + ')'}
            size="s"
            color="grey-ghost"
            onClick={() => setVisibleCount(prev => prev + ITEMS_PER_PAGE)}
          />
        </div>
      }
    </div>
  )
}

StandProducts.propTypes = {
  products: PropTypes.array.isRequired,
}

export default StandProducts
